import styled from '@emotion/styled';

const IFrame = styled('iframe')({
  border: 'none',
  maxWidth: '100%',
  overflow: 'hidden',
});

export default IFrame;
